import { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { aboutSchema } from '../shared/js/validations.js';

import '../shared/sass/CreateAndUpdateShared.scss';
import { Loader } from '../../components/Loader/Loader.jsx';
import { API_URL } from '../../config.js';
import { TextEditor } from '../../components/TextEditor/TextEditor.jsx';
import { BackButton } from '../../components/BackButton/BackButton.jsx';
import { ModalMessage } from '../../components/ModalMessage/ModalMessage.jsx';
import { Logout } from '../../components/Logout/Logout.jsx';

export const CreateAndUpdateAbout = () => {
	const { id } = useParams();
	const isEditMode = Boolean(id);

	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(null);
	const [success, setSuccess] = useState(null);

	const [data, setData] = useState({
		category: '',
		title: '',
	});
	const [description, setDescription] = useState('');

	useEffect(() => {
		if (isEditMode) {
			const fetchCategory = async () => {
				try {
					setLoading(true);
					const { data } = await axios.get(`${API_URL}/about/${id}`);
					setData({
						category: data.data.category,
						title: data.data.title,
					});
					setDescription(data.data.description || '');
				} catch (err) {
					setError('Error al cargar los datos de la categoría');
				} finally {
					setLoading(false);
				}
			};
			fetchCategory();
		}
	}, [id, isEditMode]);

	const handleChange = (event) => {
		const { name, value } = event.target;
		setData((prev) => ({ ...prev, [name]: value }));
	};

	const handleSubmit = async (event) => {
		event.preventDefault();

		setLoading(true);
		setSuccess(null);
		setError(null);

		try {
			await aboutSchema.validate(
				{
					...data,
					description,
				},
				{ abortEarly: false }
			);

			const method = isEditMode ? 'patch' : 'post';
			const url = isEditMode
				? `${API_URL}/about/${id}`
				: `${API_URL}/about`;

			await axios[method](url, {
				category: data.category,
				title: data.title,
				description,
			});

			setSuccess(
				`Categoría ${isEditMode ? 'actualizada' : 'creada'} con éxito`
			);

			if (!isEditMode) {
				setData({ category: '', title: '' });
				setDescription('');
			}
		} catch (err) {
			if (err.name === 'ValidationError') {
				setError(err.errors.join('\n')); // <-- errores de Yup
			} else if (
				err.response?.data?.errors &&
				Array.isArray(err.response.data.errors)
			) {
				const messages = err.response.data.errors
					.map((e) => e.msg)
					.join('\n'); // <-- errores de Express-validator
				setError(messages);
			} else {
				setError(err.response?.data?.message || err.message);
			}
		} finally {
			setLoading(false);
		}
	};

	return (
		<div className='CreateAndUpdateShared'>
			{loading && <Loader />}

			<div className='container'>
				{isEditMode ? (
					<BackButton
						to='/list-categories-about'
						text='Categorías About'
					/>
				) : (
					<BackButton to='/dashboard' text='Dashboard' />
				)}
				<form className='CreateAndUpdate-form' onSubmit={handleSubmit}>
					{error && (
						<ModalMessage
							type='error'
							message={error}
							onClose={() => setError(null)}
						/>
					)}
					{success && (
						<ModalMessage
							type='success'
							message={success}
							onClose={() => setSuccess(null)}
						/>
					)}
					<Logout />
					<h3>
						{isEditMode
							? 'EDITAR CATEGORÍA DE I.B.'
							: 'CREAR CATEGORÍA DE I.B.'}
					</h3>

					<label>Categoría:</label>
					<input
						type='text'
						name='category'
						onChange={handleChange}
						value={data.category}
					/>

					<label>Título:</label>
					<input
						type='text'
						name='title'
						onChange={handleChange}
						value={data.title}
					/>

					<label>Descripción:</label>
					<TextEditor
						editorState={description}
						setEditorState={setDescription}
					/>

					<button className='submit-btn' type='submit'>
						{isEditMode ? 'Actualizar' : 'Crear'} Categoría
					</button>
				</form>
			</div>
		</div>
	);
};
